import "@hotwired/turbo-rails";
import "./controllers";
import posthog from "posthog-js";

if (window.location?.origin === "https://app.startcoral.com") {
  posthog.init("phc_fjx8xZQTc2WkepU7TdBazKxexGnoWDTNXu8XT3PtbZp", {
    api_host: "https://app.posthog.com",
    autocapture: false,
    capture_pageview: false,
  });

  document.addEventListener("turbo:load", () => {
    posthog.capture("$pageview");

    if (!window.posthogIdentified) {
      const distinctId = document.querySelector('meta[name="posthog-distinct-id"]')?.content;
      const email = document.querySelector('meta[name="posthog-email"]')?.content;
      const name = document.querySelector('meta[name="posthog-name"]')?.content;

      if (distinctId) {
        posthog.identify(distinctId, { email: email, name: name });
        window.posthogIdentified = true;
      }
    } else if (window.location.pathname === "/users/login") {
      posthog.reset();
      window.posthogIdentified = false;
    }
  });
}
